import { combineReducers } from 'redux'

import {
  AccountListRequestedAction,
  AccountListReceivedAction,
} from '../actions/accountListActions'

function list(state = null, action) {
  switch (action.type) {
    case AccountListRequestedAction.NAME: {
      return null
    }
    case AccountListReceivedAction.NAME: {
      return action.data
    }
    default: {
      return state
    }
  }
}

export default combineReducers({
  list,
})
